export default __webpack_public_path__ + "static/media/move03.30af28ed.png";